export default __webpack_public_path__ + "static/media/donor_1.21df8587.jpg";